/* global axios */

import ApiClient from './ApiClient';

class VendorPortals extends ApiClient {
  constructor() {
    super('vendor_portals', { accountScoped: true });
  }

  testConnection(id) {
    return axios.post(`${this.url}/${id}/test_connection`);
  }
}

export default new VendorPortals();
